<template>
  <div class="associated-url-attributes">
    <base-check-box v-for="item in urlAttributes"
                      :label="item.label"
                      v-model="$parent.urlDataModel.associated_url_attributes[item.id]"
                      :key="item.id" />
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'AssociatedURLAttributes',
  computed: {
    ...mapState('urlCensus', ['urlAttributes'])
  }
}
</script>

<style lang="scss" scoped>
  .associated-url-attributes {
    display: flex;
    flex-direction: column;
    margin-top: 30px;

    label {
      margin: 5px 0;

      &:first-child {
        margin-top: 0;
      }

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
</style>
